<template>
  <div class="breadcrumb clearfix">
    <!-- <span>您的位置：</span> -->
    <span v-for="(item, index) in menuitems" :key="item.id">
      <span class="breadcrumb-item-link" @click="breadcrumbLink(item)"
        ><a href="#">{{ item.title }}</a></span
      >
      <span
        v-if="index !== menuitems.length - 1"
        class="breadcrumb-item-separator"
      >
        <i class="iconfont icon-arrow-db"></i>
      </span>
    </span>
  </div>
</template>
<script>
import link from '@/core/mixins/link'

export default {
  name: 'z-breadcrumb',
  mixins: [link],
  computed: {
    menuitems() {
      let category = this.$route.params.category || this.$route.meta.id // 从地址栏拿栏目的ID
      let breadcrumb = this.$store.getters['CategoriesStore/breadcrumb'](
        category
      )
      return breadcrumb
    }
  },
  methods: {
    breadcrumbLink(item) {
      item.category = item.id
      this.link(item)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.deep-breadcrumb.breadcrumb {
  color: $c-breadcrumb-deep-font;
  a {
    color: $c-breadcrumb-deep-font;
  }
}
.breadcrumb {
  display: inline-block;
  width: auto;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: $c-white;
  a {
    color: $c-white;
  }
  span {
    display: inline-block;
  }
  .breadcrumb-item-link {
    padding: 0 14px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .breadcrumb-item-separator {
    vertical-align: top;
  }
}
</style>
